import bridge from 'libs/bridge';
let disableCount = 0;
let disableLock = false;
/**
 * 禁用native的右滑返回
 */
export function disableSwipe(isForceDisabled?: boolean, lock?: boolean) {
    if (disableCount === 0 || isForceDisabled) {
        if (bridge.supports('webviewControl')) {
            bridge.call('webviewControl', {
                type: 'fullscreen-pop',
                args: {
                    enable: false
                }
            });
        }
        console.log('bytedance://disable_swipe');
    }
    if (lock) disableLock = true;
    disableCount++;
}

/**
 * 当没有别处禁用右滑返回时，重新启用native的右滑返回
 */
export function enableSwipe(isForceEnabled?: boolean) {
    if (disableLock) return;

    if (disableCount > 0) {
        disableCount--;
    }
    if (disableCount === 0 || isForceEnabled) {
        if (bridge.supports('webviewControl')) {
            bridge.call('webviewControl', {
                type: 'fullscreen-pop',
                args: {
                    enable: true
                }
            });
        }
        console.log('bytedance://enable_swipe');
    }
}
